// If you don't want to use TypeScript you can delete this file!
import axios from "axios";
import React, { useState } from "react";
import { useForm, useFormState } from "react-hook-form";

type DataProps = {
  // children: any;
};

const Layout: React.FC<DataProps> = ({ children }) => {
  const { register, handleSubmit, reset, control } = useForm();
  const { errors } = useFormState({ control: control });
  const [formResult, setFormResult] = useState(null);
  const onSubmit = (data) => {
    if (formResult == "loading") return;

    setFormResult("loading");
    axios
      .post("https://submit-form.com/DZa5XG7YiyOjQwPHcMied", {
        name: data.name,
        email: data.email,
        phone: data.phone,
        subject: data.subject,
        message: data.message,
      })
      .then((r) => {
        setFormResult("success");
        reset();
      })
      .catch(() => {
        setFormResult("error");
      });
  };
  return (
    <div className="flex justify-center">
      <form
        onSubmit={handleSubmit(onSubmit)}
        id="contactF"
        className=" w-full max-w-md"
      >
        <div className="pb-5">
          <div className="pb-5">
            Write to me in{" "}
            <a className="underline" href="mailto:anand.a6@outlook.com">
              <div className="nobr">anand.a6@outlook.com</div>
            </a>
          </div>
          <div className="pb-5">
            Reach me at{" "}
            <div className="nobr">
              <a target="_blank" className="underline" href="tel:+971557332633">
                +971-557332633
              </a>
              ,{" "}
              <a target="_blank" className="underline" href="tel:+919020342527">
                +91-9020342527
              </a>
            </div>
          </div>
        </div>
        <div className="block w-full pt-5">
          <label form="contactF">
            Name<sup>&#8727;</sup>
          </label>
          <input
            className="block w-full"
            type="text"
            {...register("name", { required: true })}
          ></input>
          {errors.name && (
            <span className="text-xs text-red-900">Required Filed</span>
          )}
        </div>
        <div className="block w-full pt-5">
          <label form="contactF">
            Email<sup>&#8727;</sup>
          </label>
          <input
            {...register("email", { required: true })}
            className="block w-full"
            type="email"
          ></input>
          {errors.email && (
            <span className="text-xs text-red-900">Required Filed</span>
          )}
        </div>
        <div className="block w-full pt-5">
          <label form="contactF">Phone</label>
          <input
            {...register("phone")}
            className="block w-full"
            type="phone"
          ></input>
        </div>
        <div className="block w-full pt-5">
          <label form="contactF">
            Subject<sup>&#8727;</sup>
          </label>
          <input
            {...register("subject", { required: true })}
            className="block w-full"
            type="text"
          />
          {errors.subject && (
            <span className="text-xs text-red-900">Required Filed</span>
          )}
        </div>
        <div className="block w-full pt-5">
          <label form="contactF">
            Message<sup>&#8727;</sup>
          </label>
          <textarea
            {...register("message", { required: true })}
            className="block  w-full"
            rows={5}
            minLength={10}
          ></textarea>
          {errors.message && (
            <span className="text-xs text-red-900">Required Filed</span>
          )}
        </div>
        <div className="block w-full pt-5">
          <button
            onClick={() => {
              setFormResult(null);
            }}
            className="block w-full bg-black p-3 text-white"
            type="submit"
          >
            {formResult != "loading" ? "Submit" : "Submitting..."}
          </button>
        </div>
        {Object.keys(errors).length === 0 && formResult === "success" && (
          <span className="text-xs text-green-900">Form submitted</span>
        )}
        {formResult === "error" && (
          <span className="text-xs text-red-900">Failed! Try again.</span>
        )}
      </form>
    </div>
  );
};

export default Layout;
